// extracted by mini-css-extract-plugin
export default {"feedbackMenu":"FeedbackMenuClean-feedbackMenu--d9ca5"};